import deburr from 'lodash/deburr'
import { map } from './CharMapper'

export const slugify = (input: string) => {
  if (input) {
    const slug = deburr(
      input.toLocaleLowerCase().replace(/./g, (matched: string) => map[matched] ?? matched)
    )
      .replace(/'|’|`|ʼ|`|´|ʹ|ʻ|ʽ|ʾ|ʿ|ˈ|ˊ|ˮ|"/g, '') // Remove special apostrophes and quotes
      .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
      .replace(/^-|-$/g, '') // Trim hyphens from start and end
    return slug
  }
}
